import { PermissionType } from "@shared/api"
import { retryDynamicImport } from "@shared/lib"
import { languageManagement, outbox } from "@shared/routes"
import { RouteGuard } from "@shared/ui/route-guard"
import { Outlet, RouteObject } from "react-router-dom"

export default [
	{
		path: outbox,
		element: (
			<RouteGuard
				requiredPermissions={[
					PermissionType.Admin,
					PermissionType.Developer,
				]}
			>
				<Outlet />
			</RouteGuard>
		),
		children: [
			{
				index: true,
				lazy: () =>
					retryDynamicImport(() => import("../outbox")).then(m => ({
						Component: m.OutboxPage,
					})),
			},
		],
	},
	{
		path: languageManagement,
		element: (
			<RouteGuard
				requiredPermissions={[
					PermissionType.Admin,
					PermissionType.Developer,
				]}
			>
				<Outlet />
			</RouteGuard>
		),
		children: [
			{
				index: true,
				lazy: () =>
					retryDynamicImport(
						() => import("../language-management"),
					).then(m => ({
						Component: m.LanguageManagementPage,
					})),
			},
		],
	},
] satisfies RouteObject[]
